import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0273a3d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "client-logo",
    style: { "text-align": "center" }
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "header-link-caret" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-chevron-right" })
], -1 /* HOISTED */));
const _hoisted_5 = {
    key: 0,
    class: "type-filter-pills",
    style: { "padding": "8px 15px 0" }
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "search-form" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { style: { "text-decoration": "underline" } };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("a", null, "No matches found", -1 /* HOISTED */));
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElImage, } from "element-plus";
import extoleLogoGrey from "assets/extole-logo-grey.png";
import Session from "js/Session";
import { computed, ref, watch } from "vue";
import { useFilteredClients } from "src/shared/store/client/composables";
import { useExtoleNavbarToggle } from "../composables";
import Strings from "src/shared/Strings";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClientSelector',
    setup(__props) {
        const session = Session.getInstance();
        const brandImageUrl = session.axiosPrefilter.processUrl("/api/v2/logo/image");
        const search = ref("");
        const searchInput = ref(null);
        const selectedIndex = ref(0);
        const typeFilter = ref(null);
        const clientTypes = [
            "CUSTOMER",
            "PROSPECT",
            "TEST",
            "EX_CUSTOMER",
            "UNCLASSIFIED",
        ];
        const { isNavbarCollapsed } = useExtoleNavbarToggle();
        const isSuperUser = session.isSuperUser();
        const searchedClients = useFilteredClients({ search }, {
            parameters: ref({
                limit: 10000,
                currentPageNumber: 1,
            }),
        });
        const highlightedItems = computed(() => {
            const byType = searchedClients.value.filter((client) => typeFilter.value === null ||
                client.client_type === typeFilter.value);
            return byType.map((client, index) => {
                const matchIndex = client.name
                    .toUpperCase()
                    .indexOf(search.value.toUpperCase());
                if (search.value === "" || matchIndex === -1) {
                    return {
                        index,
                        value: client,
                        isMatch: false,
                    };
                }
                const matchLength = search.value.length;
                return {
                    index,
                    value: client,
                    isMatch: true,
                    beforeMatch: client.name.substring(0, matchIndex),
                    match: client.name.substring(matchIndex, matchIndex + matchLength),
                    afterMatch: client.name.substring(matchIndex + matchLength),
                };
            });
        });
        const selectCurrentItem = () => {
            const currentItem = highlightedItems.value[selectedIndex.value];
            if (currentItem) {
                selectItem(currentItem.value.client_id);
            }
        };
        const navigateUp = (event) => {
            event.preventDefault();
            if (highlightedItems.value.length === 0)
                return;
            selectedIndex.value =
                selectedIndex.value <= 0
                    ? highlightedItems.value.length - 1
                    : selectedIndex.value - 1;
        };
        const navigateDown = (event) => {
            event.preventDefault();
            if (highlightedItems.value.length === 0)
                return;
            selectedIndex.value =
                selectedIndex.value >= highlightedItems.value.length - 1
                    ? 0
                    : selectedIndex.value + 1;
        };
        const selectItem = (value) => {
            session.update({
                client_id: value,
            });
        };
        const clear = () => {
            var _a;
            search.value = "";
            selectedIndex.value = 0;
            (_a = searchInput.value) === null || _a === void 0 ? void 0 : _a.focus();
        };
        // Reset selection to top when search changes
        watch(search, () => {
            selectedIndex.value = 0;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDropdown), {
                class: "button dropdown client-data-wrapper",
                trigger: "click",
                size: "large",
                placement: "top-start",
                onCommand: selectItem,
                onVisibleChange: clear,
                "popper-class": "list list--drop-down list--drop-down--modern list--drop-down--clients",
                "popper-options": {
                    placement: 'right',
                },
                teleported: false
            }, {
                dropdown: _withCtx(() => [
                    (_unref(isSuperUser))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("span", {
                                class: _normalizeClass(["client-type-badge", { active: typeFilter.value === null }]),
                                onClick: _cache[0] || (_cache[0] = () => (typeFilter.value = null))
                            }, "All", 2 /* CLASS */),
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(clientTypes, (t) => {
                                return _createElementVNode("span", {
                                    key: t,
                                    class: _normalizeClass(["client-type-badge", [
                                            `client-type-badge--${_unref(Strings).encodeLabel(_unref(Strings).capitalize(t))}`,
                                            { active: typeFilter.value === t },
                                        ]]),
                                    onClick: () => (typeFilter.value = t)
                                }, _toDisplayString(_unref(Strings).capitalize(t)), 11 /* TEXT, CLASS, PROPS */, _hoisted_6);
                            }), 64 /* STABLE_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            ref_key: "searchInput",
                            ref: searchInput,
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((search).value = $event)),
                            onKeydown: [
                                _withKeys(selectCurrentItem, ["enter"]),
                                _withKeys(navigateUp, ["arrow-up"]),
                                _withKeys(navigateDown, ["arrow-down"])
                            ],
                            autofocus: ""
                        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelText, search.value]
                        ])
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createVNode(_unref(ElDropdownMenu), { ref: "dropdown" }, {
                                default: _withCtx(() => [
                                    (highlightedItems.value.length > 0)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(highlightedItems.value, (client) => {
                                            return (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                                key: client.value.client_id,
                                                command: client.value.client_id,
                                                class: _normalizeClass({
                                                    highlighted: client.index === selectedIndex.value,
                                                })
                                            }, {
                                                default: _withCtx(() => [
                                                    (client.isMatch)
                                                        ? (_openBlock(), _createElementBlock("a", _hoisted_8, [
                                                            _createElementVNode("span", null, _toDisplayString(client.beforeMatch), 1 /* TEXT */),
                                                            _createElementVNode("span", _hoisted_9, _toDisplayString(client.match), 1 /* TEXT */),
                                                            _createElementVNode("span", null, _toDisplayString(client.afterMatch), 1 /* TEXT */)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("a", _hoisted_10, _toDisplayString(client.value.name), 1 /* TEXT */)),
                                                    (_unref(isSuperUser))
                                                        ? (_openBlock(), _createElementBlock("span", {
                                                            key: 2,
                                                            class: _normalizeClass(["client-type-badge", `client-type-badge--${_unref(Strings).encodeLabel(_unref(Strings).capitalize(client.value.client_type))}`])
                                                        }, _toDisplayString(_unref(Strings).capitalize(client.value.client_type)), 3 /* TEXT, CLASS */))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["command", "class"]));
                                        }), 128 /* KEYED_FRAGMENT */))
                                        : (_openBlock(), _createBlock(_unref(ElDropdownItem), { key: 1 }, {
                                            default: _withCtx(() => [
                                                _hoisted_11
                                            ]),
                                            _: 1 /* STABLE */
                                        }))
                                ]),
                                _: 1 /* STABLE */
                            }, 512 /* NEED_PATCH */)
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(ElImage), {
                            class: "client-brand-image",
                            src: _unref(brandImageUrl)
                        }, {
                            error: _withCtx(() => [
                                _createElementVNode("img", { src: _unref(extoleLogoGrey) }, null, 8 /* PROPS */, _hoisted_2)
                            ]),
                            placeholder: _withCtx(() => [
                                _createElementVNode("img", { src: _unref(extoleLogoGrey) }, null, 8 /* PROPS */, _hoisted_3)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["src"])
                    ]),
                    _withDirectives(_createElementVNode("span", { class: "client-name" }, _toDisplayString(_unref(session).getClientName()), 513 /* TEXT, NEED_PATCH */), [
                        [_vShow, !_unref(isNavbarCollapsed)]
                    ]),
                    _hoisted_4
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
